const o=o=>"function"==typeof o;export{o as isFunction};
